import { render, staticRenderFns } from "./PartnerActive.vue?vue&type=template&id=c10d34ac&scoped=true"
import script from "./PartnerActive.vue?vue&type=script&lang=js"
export * from "./PartnerActive.vue?vue&type=script&lang=js"
import style0 from "./PartnerActive.vue?vue&type=style&index=0&id=c10d34ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10d34ac",
  null
  
)

export default component.exports